






















































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TimePicker } from 'element-ui';
import { PopSettingsVO } from '@/model/FormWheel';
import YcColorPicker from '@/components/color-picker/index.js';
import TextAlignPicker from '@/components/text-align/index.vue';
import FontPicker from '@/components/FontPicker/index.vue';
import {
  predefineColors,
  rgbaBackgroundPredefineColors,
  borderRadiusOptions,
  fontSizeOptions
} from '@/views/wheelOfFortune/constant/options';
import { isEnableFontPicker } from '@/utils/experiment';
import {
  EXT_COUNTDOWN_PRESET_DEMO_UNITS,
  EXT_COUNTDOWN_PRESET_IDS,
  extCountdownBorderRadiusOptToNum,
  extCountdownPresetDigitFontSize,
  extCountdownPresetSuffixFontSize
} from './extendedCountdownPresets';
import { getShopTimezoneRaw } from './extendedCountdownTimezone';
import {
  applyExtendedCountdownPreset,
  applyExtFixedDateDefaultEndDateIfEmpty,
  applyExtFixedDurationDefaultIfZero,
  clampExtCountdownEndDateTimeToNowOrFuture,
  getExtCountdownDigitBorderRadiusSelectValue,
  getExtCountdownEndDatePickerOptions,
  getExtCountdownEndTimePickerOptions,
  getExtFixedDurationMinutesMax,
  getExtFixedDurationSecondsMax,
  hasNonEmptyExtendedCountdownConfig,
  normalizeExtCountdownDurationToMinutesSecondsForRules,
  patchExtendedCountdownReactive,
  syncExtendedCountdownFontToStyleMap,
  syncLegacyCountDownFromExtFixedDuration
} from './extendedCountdownModel';
import {
  formatTodayYmd,
  normalizeHms,
  parseEndDateParts,
  parseEndTimestamp,
  shopDateTimeToTimestamp,
  shopPartsFromTimestamp
} from './extendedCountdownTimezone';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'text-align-picker': TextAlignPicker,
    'font-picker': FontPicker,
    ElTimePicker: TimePicker
  }
})
export default class ExtendedCountdownSetting extends Vue {
  @Prop({ required: true })
  settings!: PopSettingsVO;

  @Prop({ type: Boolean, default: false })
  hasTemplateIdInUrl!: boolean;

  predefineColors = predefineColors;
  rgbaBackgroundPredefineColors = rgbaBackgroundPredefineColors;
  borderRadiusOptions = borderRadiusOptions;
  fontSizeOptions = fontSizeOptions;
  extCountdownPresetDemoUnits = EXT_COUNTDOWN_PRESET_DEMO_UNITS;
  endDatePickerOptions = getExtCountdownEndDatePickerOptions();
  endTimePickerOptions = getExtCountdownEndTimePickerOptions('');
  /** 面板内展示用 v-model，点「确定」(@change) 再写入 rules.endDate */
  localEndTimeHm = '23:59';
  isEndTimePickerOpen = false;
  /** blur 早于「确定」触发时，用于避免把已选时间误还原 */
  endTimePickerCommitGen = 0;

  get enableFontPicker() {
    return isEnableFontPicker();
  }

  get timezoneDisplay() {
    return getShopTimezoneRaw();
  }

  get extFixedDurationMinutesMax() {
    return getExtFixedDurationMinutesMax(this.settings.countdown);
  }

  get extFixedDurationSecondsMax() {
    return getExtFixedDurationSecondsMax(this.settings.countdown);
  }

  get extCountdownPresetList() {
    return EXT_COUNTDOWN_PRESET_IDS;
  }

  get extCountdownActivePresetId(): string {
    const v = this.settings.countdown?.styles?.variant;
    const s = String(v == null ? '1' : v).trim();
    return ['1', '2', '3', '4'].includes(s) ? s : '1';
  }

  /** 预设 2、4 有单位间分隔符，才展示分隔符文案/颜色配置 */
  get extCountdownShowSeparatorSettings(): boolean {
    const id = this.extCountdownActivePresetId;
    return id === '2' || id === '4';
  }

  get extCountdownEndDateYmd(): string {
    return parseEndDateParts(this.settings.countdown?.rules?.endDate).date;
  }

  /** 与 el-time-picker value-format="HH:mm" 对齐，避免 HH:mm:ss 导致面板滚轮不同步 */
  get extCountdownEndTimeHm(): string {
    const end = this.settings.countdown?.rules?.endDate;
    if (end == null || !String(end).trim()) return '23:59';
    const p = parseEndDateParts(end);
    const t = p.time || '23:59:59';
    return t.length >= 5 ? t.slice(0, 5) : '23:59';
  }

  @Watch('extCountdownEndDateYmd', { immediate: true })
  syncEndTimePickerOptions() {
    this.endTimePickerOptions = getExtCountdownEndTimePickerOptions(this.extCountdownEndDateYmd);
    if (!this.isEndTimePickerOpen) {
      this.ensureEndTimeWithinSelectableRangeForDate();
      this.localEndTimeHm = this.extCountdownEndTimeHm;
    }
  }

  @Watch('extCountdownEndTimeHm', { immediate: true })
  syncLocalEndTimeFromRules(hm: string) {
    if (!this.isEndTimePickerOpen) {
      this.localEndTimeHm = hm;
    }
  }

  get extCountdownFontSizeSelectValue(): string {
    const variant = String(this.settings.countdown?.styles?.variant || '1');
    const n =
      this.settings.countdown?.styles?.fontSize ?? extCountdownPresetDigitFontSize(variant);
    return `${n}px`;
  }

  get extCountdownFontSizeOptionList(): string[] {
    const list = [...this.fontSizeOptions];
    const cur = this.extCountdownFontSizeSelectValue;
    if (cur && !list.includes(cur)) list.unshift(cur);
    return list;
  }

  get extCountdownSuffixFontSizeSelectValue(): string {
    const variant = String(this.settings.countdown?.styles?.variant || '1');
    const n =
      this.settings.countdown?.styles?.suffixFontSize ?? extCountdownPresetSuffixFontSize(variant);
    return `${n}px`;
  }

  get extCountdownSuffixFontSizeOptionList(): string[] {
    const list = [...this.fontSizeOptions];
    const cur = this.extCountdownSuffixFontSizeSelectValue;
    if (cur && !list.includes(cur)) list.unshift(cur);
    return list;
  }

  get extCountdownDigitBorderRadiusSelectValue(): string {
    return getExtCountdownDigitBorderRadiusSelectValue(this.settings.countdown, this.borderRadiusOptions);
  }

  mounted() {
    const cd = this.settings.countdown;
    if (!cd) return;
    const defaultShowTimeUnitLabels = this.hasTemplateIdInUrl || hasNonEmptyExtendedCountdownConfig(cd);
    patchExtendedCountdownReactive(cd, this.settings, defaultShowTimeUnitLabels);
  }

  emitChange() {
    this.$emit('change');
  }

  onExtCountdownFontFamilyChange(val: string) {
    const cd = this.settings.countdown;
    if (!cd?.styles) return;
    Vue.set(cd.styles, 'fontFamily', val || '');
    syncExtendedCountdownFontToStyleMap(this.settings);
    this.emitChange();
  }

  onExtCountdownSuffixFontFamilyChange(val: string) {
    const cd = this.settings.countdown;
    if (!cd?.styles) return;
    Vue.set(cd.styles, 'suffixFontFamily', val || '');
    syncExtendedCountdownFontToStyleMap(this.settings);
    this.emitChange();
  }

  onExtCountdownFontSizeSelect(val: string) {
    const cd = this.settings.countdown;
    if (!cd) return;
    const n = parseInt(String(val).replace(/px/gi, ''), 10);
    if (!Number.isNaN(n)) {
      Vue.set(cd.styles, 'fontSize', n);
      this.emitChange();
    }
  }

  onExtCountdownSuffixFontSizeSelect(val: string) {
    const cd = this.settings.countdown;
    if (!cd) return;
    const n = parseInt(String(val).replace(/px/gi, ''), 10);
    if (!Number.isNaN(n)) {
      Vue.set(cd.styles, 'suffixFontSize', n);
      this.emitChange();
    }
  }

  onExtCountdownDigitBorderRadiusSelect(val: string) {
    const cd = this.settings.countdown;
    if (!cd?.styles?.digitBackground) return;
    Vue.set(cd.styles.digitBackground, 'borderRadius', extCountdownBorderRadiusOptToNum(val));
    this.emitChange();
  }

  onExtCountdownRulesTypeChange() {
    const rules = this.settings.countdown?.rules;
    if (!rules) return;
    if (rules.type === 'fixed_duration') {
      normalizeExtCountdownDurationToMinutesSecondsForRules(rules);
      applyExtFixedDurationDefaultIfZero(rules);
      syncLegacyCountDownFromExtFixedDuration(this.settings);
    }
    if (rules.type === 'fixed_date') {
      applyExtFixedDateDefaultEndDateIfEmpty(rules);
      clampExtCountdownEndDateTimeToNowOrFuture(rules);
    }
    this.emitChange();
  }

  onExtFixedDurationPartsChange() {
    const rules = this.settings.countdown?.rules;
    if (!rules?.duration) return;
    normalizeExtCountdownDurationToMinutesSecondsForRules(rules);
    applyExtFixedDurationDefaultIfZero(rules);
    syncLegacyCountDownFromExtFixedDuration(this.settings);
    this.emitChange();
  }

  parseTimePickerValue(val: string | Date | null): string {
    if (val == null || val === '') return '00:00:00';
    if (val instanceof Date && !Number.isNaN(val.getTime())) {
      const hh = `${val.getHours()}`.padStart(2, '0');
      const mm = `${val.getMinutes()}`.padStart(2, '0');
      const ss = `${val.getSeconds()}`.padStart(2, '0');
      return `${hh}:${mm}:${ss}`;
    }
    const s = String(val).trim();
    if (/^\d{1,2}:\d{2}$/.test(s)) {
      const p = s.split(':');
      return `${String(parseInt(p[0], 10) || 0).padStart(2, '0')}:${String(parseInt(p[1], 10) || 0).padStart(2, '0')}:00`;
    }
    return normalizeHms(s);
  }

  /** 选「今天」时，若结束时刻早于店铺当前时刻，自动抬到当前时刻（与 selectableRange 一致） */
  ensureEndTimeWithinSelectableRangeForDate() {
    const rules = this.settings.countdown?.rules;
    if (!rules || rules.type !== 'fixed_date') return;
    const raw = rules.endDate;
    if (raw == null || !String(raw).trim()) return;
    const dateYmd = parseEndDateParts(raw).date || formatTodayYmd();
    const todayStr = formatTodayYmd();
    if (dateYmd > todayStr) return;

    const nowParts = shopPartsFromTimestamp(Date.now());
    const endParts = parseEndDateParts(raw);
    const endMs = parseEndTimestamp(raw);
    const minMs = shopDateTimeToTimestamp(dateYmd, nowParts.time);
    if (!Number.isNaN(endMs) && !Number.isNaN(minMs) && endMs < minMs) {
      Vue.set(rules, 'endDate', String(minMs));
    }
  }

  applyEndTimeFromPicker(val: string | Date | null, notify: boolean) {
    const rules = this.settings.countdown?.rules;
    if (!rules) return;
    const { date } = parseEndDateParts(rules.endDate);
    const d = date || formatTodayYmd();
    const tm = this.parseTimePickerValue(val);
    const newMs = shopDateTimeToTimestamp(d, tm);
    if (Number.isNaN(newMs)) return;
    Vue.set(rules, 'endDate', String(newMs));
    if (newMs <= Date.now()) {
      clampExtCountdownEndDateTimeToNowOrFuture(rules);
    }
    if (notify) this.emitChange();
  }

  onExtCountdownEndDateInput(val: string | null) {
    const rules = this.settings.countdown?.rules;
    if (!rules) return;
    const { time } = parseEndDateParts(rules.endDate);
    const t = time || '00:00:00';
    if (!val) {
      Vue.set(rules, 'endDate', '');
    } else {
      Vue.set(rules, 'endDate', String(shopDateTimeToTimestamp(val, t)));
    }
    this.ensureEndTimeWithinSelectableRangeForDate();
    clampExtCountdownEndDateTimeToNowOrFuture(rules);
    if (!this.isEndTimePickerOpen) {
      this.localEndTimeHm = this.extCountdownEndTimeHm;
    }
    this.emitChange();
  }

  onEndTimePickerFocus() {
    this.isEndTimePickerOpen = true;
  }

  /** 面板开关：仅在打开时同步；关闭时若非「确定」提交则还原（避免点「分」列触发 input blur 把小时改回 23） */
  onEndTimePickerVisibleChange(visible: boolean) {
    if (visible) {
      this.isEndTimePickerOpen = true;
      this.localEndTimeHm = this.extCountdownEndTimeHm;
      return;
    }
    const genAtClose = this.endTimePickerCommitGen;
    this.$nextTick(() => {
      if (this.endTimePickerCommitGen !== genAtClose) return;
      this.isEndTimePickerOpen = false;
      this.localEndTimeHm = this.extCountdownEndTimeHm;
    });
  }

  /** 滚轮点选会更新输入框(v-model)；点「确定」后写入配置并通知父级 */
  onExtCountdownEndTimeConfirm(val: string | Date | null) {
    this.endTimePickerCommitGen += 1;
    this.isEndTimePickerOpen = false;
    const picked = val != null && val !== '' ? val : this.localEndTimeHm;
    const tm = this.parseTimePickerValue(picked);
    this.localEndTimeHm = tm.length >= 5 ? tm.slice(0, 5) : this.localEndTimeHm;
    this.applyEndTimeFromPicker(this.localEndTimeHm, false);
    this.localEndTimeHm = this.extCountdownEndTimeHm;
    this.$nextTick(() => this.emitChange());
  }

  applyExtendedCountdownPreset(id: string) {
    applyExtendedCountdownPreset(this.settings, id);
    this.emitChange();
  }
}
